export default "__VITE_ASSET__CTj1dtAo__"